export enum UserRoleEnum {
	VENUEUSER = 1,
	VENUEADMIN = 2,
	DEALERUSER = 3,
	DEALERADMIN = 4,
	SUPERADMIN = 5,
	GOD = 6,
}
